<!-- 由 suu 创建于 2022-01-08 星期六 -->
<template>
  <div class="ItemTest">
    <div
      class="it-item"
      v-for="(item, index) in more ? list : list.slice(0, initLen)"
      :key="index"
    >
      <div class="i-title">{{ item.title }}</div>
      <div class="i-nums">
        <div class="n-top">
          {{ item.clock }}/<span>{{ item.all }}</span>
        </div>
        <div
          class="n-tag"
          :style="{ backgroundColor: nTagColor(item.tag.type) }"
        >
          {{ item.tag.text }}
        </div>
      </div>
      <div class="i-sub">
        <div>当前进度 {{ item.subValue }}</div>
        <div class="sub-gray">建议进度 {{ item.subValue2 }}</div>
      </div>
    </div>
    <div
      class="it-btn user-btn"
      @click="more = !more"
      v-if="list.length > initLen"
    >
      {{ more ? '收起' : '展开' }}
      <van-icon :name="'arrow-' + (more ? 'up' : 'down')" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemTest',

  components: {},

  props: {
    list: {}
  },

  data() {
    return {
      initLen: 4,
      more: false
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 获取打卡标签颜色
     */
    nTagColor(type) {
      switch (type) {
        case 1:
          return '#F04646'
        case 3:
          return '#35C763'
        default:
          return '#2882E9'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ItemTest {
  width: 100%;
  box-sizing: border-box;
  background: #f7f7f7;
  border-radius: 6px;
  border: 1px solid #f1f1f1;
  .it-item {
    height: 58px;
    display: flex;
    align-items: center;
    text-align: center;
    border-bottom: 1px solid #f1f1f1;
    > div {
      height: 100%;
    }
    .i-title {
      flex: 1;
      border-right: 1px solid #f1f1f1;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .i-nums {
      flex: 2;
      border-right: 1px solid #f1f1f1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .n-top {
        font-size: 15px;
        font-weight: 500;
        span {
          font-size: 10px;
          font-weight: 400;
        }
      }
      .n-tag {
        width: 50px;
        height: 15px;
        color: #fff;
        font-size: 10px;
        font-weight: 500;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 2px;
      }
    }
    .i-sub {
      flex: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      line-height: 17px;
      .sub-gray {
        color: #7f7f7f;
        margin-top: 2px;
      }
    }
  }
  .it-btn {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    font-size: 13px;
    font-weight: 500;
    color: #2882e9;
    i {
      margin-left: 7px;
    }
  }
}
</style>
